<template>
    <div>
        <header-block ref="header"></header-block>
        <div class="container">
            <div class="slider" ref="slider">
                <template v-for="block in blocks">
                    <content-block ref="block" :item="block" ></content-block>
                </template>
            </div>
            <div class="contact-overlay" ref="contactOverlay">
                <div class="content-block--video--close" v-on:click="toggleOverlay">
                    <span></span>
                    <span></span>
                </div>
                <div class="contact-overlay--container">
                    <img class="logo" src="/static/images/logo.png" alt="logo" />
                    <h3>Call +31 6 55 10 63 20<br />
                        or <a class="mail" href="mailto:mail@johnhorjus.nl">mail@johnhorjus.nl</a></h3>
                    <a class="linkedIn" href="https://www.linkedin.com/in/johnhorjus/" target="_blank">
                        <img src="/static/images/linkedin.png" alt="linkedin" />
                    </a>
                </div>
            </div>
        </div>
        <div class="mobile-fallback">
            <div class="mobile-fallback--inner">
                <img src="static/images/rotate.png" alt="rotate" />
                <p>Please turn your device.</p>
            </div>
        </div>
    </div>
</template>

<style src="./assets/css/app.scss" lang="scss"></style>

<script>
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    ga('create', 'UA-28839430-17', 'auto');
    ga('send', 'pageview');

</script>

<script>
    import ContentBlock from './components/ContentBlock.vue'
    import HeaderBlock from './components/HeaderBlock.vue'
    import {TweenLite, TimelineLite, Power2} from 'gsap';

    export default {
        name: 'app',
        components: {
            ContentBlock,
            HeaderBlock
        },
        data () {
            return {
                blocks: [
                    {
                        background: 'background-9.jpg',
                        title: 'Your Story',
                        subTitle: 'I BRING IT TO LIVE IN CAMPAIGNS, CONTENT AND ACTIVATION',
                        videoUrl: '278625232',
                        footerTop: 'TO PROTECT WHAT WE VALUE MOST / MINISTRY OF DEFENCE',
                        footerBottom: 'Online advertising, TV, cinema / Agency: Steam / Director: Daniel Dow',
                        template: 'one'
                    },
                    {
                        background: 'background-7.jpg',
                        videoUrl: '219381520',
                        footerTop: 'THE SWIMMER / MINISTRY OF DEFENCE',
                        footerBottom: 'Online advertising, lifehacks, cinema, TV / Agency: Steam - Maarten Kuipers / Director: Nanno Jiskoot',
                        template: 'two'
                    },
                    {
                        background: 'background-1.jpg',
                        videoUrl: '250605329',
                        footerTop: 'SKILLED FOR LIFE / MINISTRY OF DEFENCE',
                        footerBottom: 'Online advertising, cinema, TV / Agency: Steam / Director: Daniël Dow',
                        template: 'two'
                    },
//                    {
//                        background: 'background-2.jpg',
//                        videoUrl: '210899405',
//                        footerTop: 'THE LINE / MINISTRY OF DEFENCE',
//                        footerBottom: 'Online/mobile advertising, 360º website, tech blogs, TV, cinema / Agency: Steam - Maarten Kuipers / Director: Arne Toonen',
//                        template: 'two'
//                    },
//                    {
//                        background: 'background-3.jpg',
//                        videoUrl: '210899283',
//                        footerTop: 'ON THE SHOULDERS / MINISTRY OF DEFENCE',
//                        footerBottom: 'Online advertising, TV / Agency: Steam - Maarten Kuipers / Director: Arno Dierickx',
//                        template: 'two'
//                    },
                    {
                        background: 'background-8.jpg',
                        videoUrl: '210899221',
                        footerTop: 'DOMINO / MINISTRY OF DEFENCE',
                        awards: 'true',
                        footerBottom: 'Online advertising, blogs, TV, cinema / Agency: Steam - Maarten Kuipers / Director: Bram van Alphen',
                        template: 'four'
                    },
//                    {
//                        background: 'background-5.jpg',
//                        videoUrl: '210899271',
//                        footerTop: 'HEROES / MINISTRY OF DEFENCE',
//                        awards: 'true',
//                        footerBottom: 'Online advertising, tech blogs, TV, cinema, movie posters/cut-outs / Agency: Steam - Erwin Schieven / Director: Martin Koolhoven',
//                        template: 'four'
//                    },
                    {
                        background: 'background-6.jpg',
                        title: '',
                        subTitle: 'I work on many, many stories more',
                        underTitle: '',
                        clients: '<span>Advisery</span> Loyens & Loeff / McKinsey / NautaDutilh / Stibbe <span>Charity</span> Fonds verstandelijk gehandicapten / Greenpeace / Nationale Voorleesdagen (CPNB) / Vogelbescherming <span>Corporate & labour market</span> ABN AMRO / AVR / Arcadis / ASML / Belastingdienst / Bloemenveiling Aalsmeer / Canon / Ernst & Young / Essent / Flora Holland / FrieslandCampina / Heineken / KLM / KPN / Ministerie van Defensie / Nuon / NS / Rabobank / Signaal/Thales / Stork / PostNL <span>Cosmetics & body care</span> Acuvue / Nivea / Pearle / Weight Watchers <span>Drinks</span> Grolsch / Heineken / Coke light / Coolbest <span>Fashion</span> Nike / WE <span>Financials</span> AXA / Bouwfonds Hypotheken / Delta Lloyd / Ernst & Young / Huis & Hypotheek / ING / Interpay / Kempen & Co / Maestro / Menzis / Ohra / Optimix / Rabobank / Robeco / Trias / SNS Reaal / Triodos Bank / Van Lanschot Bankiers <span>Food</span> Beemsterkaas / Becel / Blue band / Calvé / Cup-a-soup / De Betuwe / Van Dobben / Festini / HAK / Hero Jam / Koopmans / Lätta / Maaslander / Magnum / Melitta / Unox <span>Government</span> Belastingdienst / De Nederlandsche Bank / Het Rijk / Ministeries van Binnenlandse Zaken / Defensie / Economische Zaken en VWS / Provincie Overijssel / UWV / BBIE <span>Hifi & TV</span> Bose / Sony / UPC <span>Household</span> Brabantia / Bosch / Celtona / Curver / Forbo / Lotus / Tefal / Vaillant <span>ICT & telecommunication</span> ASML / Atos Origin / CapGemini / Compaq / EDS / IBM / KPN / LogicaCMG / Microsoft / Telfort / Vodafone <span>Media</span> Intermediair / Kluwer / Noordhoff / RTL4 / Sanoma / STER <span>Pharmaceutical & health</span> AMC / Centocor / Davitamon / Maastricht UMC / MC Haaglanden / Ministerie van VWS en Inspectie Gezondheidszorg / Predictor / UMC Groningen / UMC Utrecht / VU Medisch Centrum <span>Retail</span> Albert / Albert Heijn / DA / De Broodzaak / Etos / Hema / KPN / Multimate / Nivea / Staatsloterij / Speurders.nl / Zeeman <span>Transport & logistics</span> Connexxion / DHL / NS / Van Oord Marine Engineering / ProRail / Shell / TLN / TNT Post <span>Travel & recreation</span> Aruba / Dolfinarium / D-Reizen / Happyhome / Holland Casino / Naturalis / Openluchtmuseum / Nederlands Bureau voor Toerisme / NEMO',
                        teaser: "Ask me about it or tell me your story: +316 5510 6320",
                        underTeaser: '',
                        template: 'five'
                    }
                ],
                count: 0,
                oldCount: 0,
                moving: false,
                overlayOpen: false
            }
        },
        mounted() {
            let isFirefox = typeof InstallTrigger !== 'undefined';
            let isIE = /*@cc_on!@*/false || !!document.documentMode;

            if (isFirefox) {
                window.addEventListener('DOMMouseScroll', this.moveSlider);
            } else if (isIE) {
                window.addEventListener('mousewheel', this.moveSlider);
            } else {
                window.addEventListener('wheel', this.moveSlider);
            }

            let _this = this;

            setTimeout(function(){
                _this.animateIn();
            }, 600);
        },
        methods: {
            moveSlider: function(e) {
                console.log('isIE2');

                e.preventDefault();

                let delta = e.wheelDelta ? e.wheelDelta : -e.detail;
                let wDelta = delta < 0 ? 'down' : 'up';
                let maxScroll = this.$refs.block.length -2;
                let header = document.querySelector('.header-block');

                if (this.moving === false && this.overlayOpen === false) {
                    this.moving = true;
                    this.oldCount = this.count;

                    if (wDelta === 'down') {
                        if (this.count <= maxScroll) {
                            this.count++;
                            this.movingAnimations();
                        } else {
                            this.moving = false;
                        }
                    } else {
                        if (this.count > 0){
                            this.count--;
                            this.movingAnimations();
                        } else {
                            this.moving = false;
                        }
                    }

                }
            },

            movingAnimations: function() {
                let tl = new TimelineLite();
                let easeAnim = Power2.easeOut;
                let contentBlocks = document.querySelectorAll('.content-block');
                let currentBlock = contentBlocks[this.oldCount];
                let playButton = currentBlock.querySelector('.content-block--play');
                let title = currentBlock.querySelector('.title');
                let subTitle = currentBlock.querySelector('.subtitle');
                let underTitle = currentBlock.querySelector('.under-title');
                let clientLine = currentBlock.querySelector('.content-block--client');
                let creditsLine = currentBlock.querySelector('.content-block--credits');
                let clientsLine = currentBlock.querySelector('.content-block--clients');
                let slider = currentBlock.querySelector('.content-block--slider');
                let teaser = currentBlock.querySelector('.teaser');
                let awards = currentBlock.querySelector('.content-block--awards');
                let underTeaser = currentBlock.querySelector('.under-teaser');

                let newBlock = contentBlocks[this.count];
                let newPlayButton = newBlock.querySelector('.content-block--play');
                let newTitle = newBlock.querySelector('.title');
                let newSubTitle = newBlock.querySelector('.subtitle');
                let newUnderTitle = newBlock.querySelector('.under-title');
                let newClientLine = newBlock.querySelector('.content-block--client');
                let newCreditsLine = newBlock.querySelector('.content-block--credits');
                let newClientsLine = newBlock.querySelector('.content-block--clients');
                let newSlider = newBlock.querySelector('.content-block--slider');
                let newTeaser = newBlock.querySelector('.teaser');
                let newAwards = newBlock.querySelector('.content-block--awards');
                let newUnderTeaser = newBlock.querySelector('.under-teaser');

                tl.addLabel('startPoint');

                if (playButton) {
                    tl.to(playButton, .3, {
                        autoAlpha: 0,
                        ease: easeAnim
                    }, 'startPoint');
                }

                if (clientsLine) {
                    tl.to(clientsLine, .3, {
                        autoAlpha: 0,
                        ease: easeAnim
                    }, 'startPoint');
                }

                if (slider) {
                    tl.to(slider, .3, {
                        autoAlpha: 0,
                        ease: easeAnim
                    }, 'startPoint');
                }

                if (awards) {
                    tl.to(awards, .3, {
                        autoAlpha: 0,
                        ease: easeAnim
                    }, 'startPoint');
                }

                if (title) {
                    tl.to(title, .3, {
                        opacity: 0,
                        y: -30,
                        ease: easeAnim
                    }, 'startPoint');
                }

                if (subTitle) {
                    tl.to(subTitle, .3, {
                        opacity: 0,
                        y: -30,
                        ease: easeAnim,
                        delay: .1
                    }, 'startPoint');
                }

                if (underTitle) {
                    tl.to(underTitle, .3, {
                        opacity: 0,
                        y: -30,
                        ease: easeAnim,
                        delay: .1
                    }, 'startPoint');
                }

                if (clientLine) {
                    tl.to(clientLine, .3, {
                        opacity: 0,
                        y: 30,
                        ease: easeAnim,
                        delay: .2
                    },'startPoint');
                }

                if (teaser) {
                    tl.to(teaser, .3, {
                        opacity: 0,
                        y: 30,
                        ease: easeAnim,
                        delay: .2
                    },'startPoint');
                }

                if (creditsLine) {
                    tl.to(creditsLine, .3, {
                        opacity: 0,
                        y: 30,
                        ease: easeAnim
                    }, 'startPoint');
                }

                if (underTeaser) {
                    tl.to(underTeaser, .3, {
                        opacity: 0,
                        y: 30,
                        ease: easeAnim
                    }, 'startPoint');
                }

                tl.to(this.$refs.slider, .8, {
                    ease: Power2.easeInOut,
                    top: '-' + 100 * this.count + '%',
                    onComplete: this.setMoving
                });

                tl.addLabel('secondPoint');

                if (this.count === contentBlocks.length - 1) {
                    if (newClientsLine) {
                        tl.to(newClientsLine, .3, {
                            autoAlpha: 1,
                            ease: easeAnim,
                            delay: .3
                        }, 'secondPoint');
                    }

                    if (newTitle) {
                        tl.to(newTitle, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newSubTitle) {
                        tl.to(newSubTitle, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: .1
                        }, 'secondPoint');
                    }

                    if (newUnderTitle) {
                        tl.to(newUnderTitle, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: .1
                        }, 'secondPoint');
                    }

                    if (newTeaser) {
                        tl.to(newTeaser, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: .9
                        }, 'secondPoint');
                    }

                    if (newUnderTeaser) {
                        tl.to(newUnderTeaser, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: 1
                        }, 'secondPoint');
                    }
                } else {
                    if (newPlayButton) {
                        tl.to(newPlayButton, .3, {
                            autoAlpha: 1,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newClientsLine) {
                        tl.to(newClientsLine, .3, {
                            autoAlpha: 1,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newSlider) {
                        tl.to(newSlider, .3, {
                            autoAlpha: 1,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newAwards) {
                        tl.to(newAwards, .3, {
                            autoAlpha: 1,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newTitle) {
                        tl.to(newTitle, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: .1
                        }, 'secondPoint');
                    }

                    if (newSubTitle) {
                        tl.to(newSubTitle, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newUnderTitle) {
                        tl.to(newUnderTitle, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newClientLine) {
                        tl.to(newClientLine, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newTeaser) {
                        tl.to(newTeaser, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim
                        }, 'secondPoint');
                    }

                    if (newCreditsLine) {
                        tl.to(newCreditsLine, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: .1
                        }, 'secondPoint');
                    }

                    if (newUnderTeaser) {
                        tl.to(newUnderTeaser, .3, {
                            opacity: 1,
                            y: 0,
                            ease: easeAnim,
                            delay: .1
                        }, 'secondPoint');
                    }
                }
            },

            setMoving: function() {
                let _this = this;

                setTimeout(function() {
                    _this.moving = false;
                }, 500);
            },

            animateIn: function() {
                let firstBlock = document.querySelector('.content-block--one');
                let playButton = document.querySelector('.content-block--play');
                let title = firstBlock.querySelector('h2');
                let subTitle = firstBlock.querySelector('h3');
                let clientLine = firstBlock.querySelector('.content-block--client');
                let creditsLine = firstBlock.querySelector('.content-block--credits');
                let header = document.querySelector('.header-block');
                let easeAnim = Power2.easeOut;
                let tl = new TimelineLite();

                tl.to(firstBlock, .5, {
                    opacity: 1,
                    ease: easeAnim
                });

                tl.addLabel('startPoint');

                tl.to(header, .7, {
                    y: 0,
                    ease: easeAnim
                }, 'startPoint');

                tl.addLabel('secondPoint');

                tl.to(playButton, .5, {
                    autoAlpha: 1,
                    ease: easeAnim
                }, 'secondPoint');

                tl.to(title, .7, {
                    opacity: 1,
                    y: 0,
                    ease: easeAnim
                }, 'secondPoint');

                tl.to(subTitle, .7, {
                    opacity: 1,
                    y: 0,
                    ease: easeAnim,
                    delay: .2
                }, 'secondPoint');

                tl.to(clientLine, .7, {
                    opacity: 1,
                    y: 0,
                    ease: easeAnim
                },'startPoint');

                tl.to(creditsLine, .7, {
                    opacity: 1,
                    y: 0,
                    ease: easeAnim,
                    delay: .2
                }, 'startPoint');
            },

            toggleOverlay: function() {
                let headerBlock = document.querySelector('.header-block');
                let easeAnim = Power2.easeOut;
                let tl = new TimelineLite();

                if (this.overlayOpen === false) {
                    TweenMax.to(headerBlock, 1, {
                        y: -100,
                        ease: easeAnim
                    });

                    tl.to(this.$refs.contactOverlay, .3, {
                        opacity: 1,
                        className:"+=active",
                        ease: easeAnim
                    });

                    this.overlayOpen = true;
                } else {
                    TweenMax.to(headerBlock, 1, {
                        y: 0,
                        ease: easeAnim
                    });

                    tl.to(this.$refs.contactOverlay, .3, {
                        opacity: 0,
                        ease: easeAnim
                    });

                    tl.to(this.$refs.contactOverlay, .1, {
                        className:"-=active",
                        ease: easeAnim
                    });

                    this.overlayOpen = false;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// App.vue?0a32b8b2